/**
 * Utility to detect Microsoft Clarity bot for static rendering
 */

export const isClarityBot = (): boolean => {
  // Server-side rendering check
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  // Check user agent for Clarity bot patterns
  const userAgent = navigator.userAgent.toLowerCase();
  const clarityPatterns = [
    'clarity',
    'claritybot',
    'microsoft.com/clarity',
    'msnbot',
    'bingpreview'
  ];
  
  const hasClarityUA = clarityPatterns.some(pattern => 
    userAgent.includes(pattern)
  );

  // Check URL parameter _clwp=1 (Clarity Web Preview)
  const urlParams = new URLSearchParams(window.location.search);
  const hasClarityParam = urlParams.get('_clwp') === '1';

  // Check hostname for clarity.microsoft.com
  const isClarityHostname = window.location.hostname.includes('clarity.microsoft.com');

  // Check for Clarity script presence
  const hasClarityScript = !!document.querySelector('script[src*="clarity.ms"]');

  // Check sessionStorage flag (can be set manually for testing)
  const hasTestFlag = sessionStorage.getItem('clarity-snapshot-mode') === 'true';

  return hasClarityUA || hasClarityParam || isClarityHostname || hasTestFlag;
};

export const isClaritySnapshotRoute = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.pathname === '/__clarity-snapshot';
};

export const enableClarityTestMode = () => {
  sessionStorage.setItem('clarity-snapshot-mode', 'true');
  window.location.reload();
};

export const disableClarityTestMode = () => {
  sessionStorage.removeItem('clarity-snapshot-mode');
  window.location.reload();
};
